export class Provider {
  /**
   * constructor description
   * @param {Object} provider - An object.
   * @param  {String} provider._id
   * @param  {String} provider.name
  */
  constructor({ name, _id }) {
    this.name = name;
    this._id = _id;
  }
}
